import axiosInstance from '../api.service.js';
import constants from '../../constants/constants';

const ENDPOINTORIGIN = "ProjectSubType/";

const getProjectSubTypeById = async (id) => await axiosInstance.get(ENDPOINTORIGIN + 'GetProjectSubTypeById?id=' + id, constants.REQUIRE_INTERCEPTORS);

const getProjectSubTypes = async () => await axiosInstance.get(ENDPOINTORIGIN + 'GetProjectSubTypes', constants.REQUIRE_INTERCEPTORS);

const saveProjectSubType = async (model) => await axiosInstance.post(ENDPOINTORIGIN + 'SaveProjectSubType', model, constants.REQUIRE_INTERCEPTORS);

const deleteProjectSubType = async (id) => await axiosInstance.get(ENDPOINTORIGIN + 'DeleteProjectSubType?id=' + id, constants.REQUIRE_INTERCEPTORS);

export {
    getProjectSubTypeById,
    getProjectSubTypes,
    saveProjectSubType,
    deleteProjectSubType
}